import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const SendMortgageeLetterEvent = BaseLoanEvent.extend({
  type: z.literal('sendMortgageeLetter'),
  ignorePreviouslySentEmailsCheck: z.boolean().optional(),
});
export type SendMortgageeLetterEvent = z.infer<typeof SendMortgageeLetterEvent>;
